import React, { useState } from "react";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import "../../assets/css/ForgotPassword.css";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import {
    clientLogo1,
    clientLogo2,
    clientLogo3,
    clientLogo4,
    clientLogo5,
    clientLogo6,
} from "../../Constant";
import { ForgotPasswordAction } from "../../redux/actions/auth";

const ForgotPassword = ({ forgotPassword }) => {
    const navigate = useNavigate();

    const [email, setEmail] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        try {
            await forgotPassword(email, () => {
                navigate(`/account-verification/${email}`);
            });
        } catch (e) {
            console.log(e);
        }
    };

    return (
        <>
            <Header />
            {/* <!-- Introduce Yourself Sec Start Here --> */}
            <section className="forget-pass">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3"></div>
                        <div className="col-md-6">
                            <div className="forget_box">
                                <div className="heading_wrapper">
                                    <h4>Forgot Password</h4>
                                    <p>
                                        Enter Your Registered email Address
                                        <br />
                                    </p>
                                </div>
                                <form
                                    id="forgotForm"
                                    className="form"
                                    action=""
                                    method="post"
                                    onSubmit={submit}
                                >
                                    <label htmlFor="forget-pass">
                                        Enter you Registered Email
                                    </label>
                                    <input
                                        required
                                        type="email"
                                        placeholder="Enter your email"
                                        className="form-control"
                                        id="email"
                                        value={email}
                                        onChange={(e) =>
                                            setEmail(e.target.value)
                                        }
                                    />
                                    {/* <!--                            <button className="buttons" type="submit">Request Password Reset</button>--> */}
                                    <input
                                        id="reset-button"
                                        type="submit"
                                        name="submit"
                                        className="buttons"
                                        value="Request Password Reset"
                                    />
                                </form>
                                <div className="signupDv">
                                    <p>
                                        Not a Member ?{" "}
                                        <Link to={"/signup"}>Sign up</Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3"></div>
                    </div>
                </div>
            </section>
            {/* <!-- Introduce Yourself Sec End Here --> */}

            {/* <!-- Brands Div Start Here --> */}
            <section className="brandsDv">
                <div className="container">
                    <hr />
                    <div className="row">
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo1} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo2} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo3} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo4} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo5} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo6} alt="" />
                                </figure>
                            </div>
                        </div>
                    </div>
                    <hr />
                </div>
            </section>
            {/* <!-- Brands Div End Here --></div> */}
            <Footer />
        </>
    );
};

const mapDispatchToProps = (dispatch) => ({
    forgotPassword: async (email, cb) =>
        dispatch(await ForgotPasswordAction(email, cb)),
});

export default connect(null, mapDispatchToProps)(ForgotPassword);
